// extracted by mini-css-extract-plugin
export default {"ctn":"p18TE","ctn-direction--row":"q7La4","action-button":"WuWl7","ctn-direction--column":"q3hRP","ctn__block":"Dvw7K","action-button__icon":"Bk7J2"};